import { DateUtils } from "../utils/DateUtils";
var Organization = /** @class */ (function () {
    function Organization() {
        this.organizationLanguageCode = "de";
        this.contactCountryCode = "CH";
        this.isSeparateBillingAddress = false;
        this.billingCountryCode = "CH";
        this.agbAccepted = false;
    }
    Object.defineProperty(Organization.prototype, "isExistingOrganization", {
        get: function () {
            return !!this.organizationId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Organization.prototype, "isSameBillingAddress", {
        // The UI uses a "same billing address" instead of a "separate
        // billing address" checkbox, hence the virtual property below.
        get: function () {
            return !this.isSeparateBillingAddress;
        },
        set: function (isSameBillingAddress) {
            this.isSeparateBillingAddress = !isSameBillingAddress;
        },
        enumerable: true,
        configurable: true
    });
    Organization.prototype.initBillingAddressIfNecessary = function () {
        if (!this.billingAddressLine1) {
            this.copyContactAddressToBillingAddress();
        }
    };
    Organization.prototype.copyContactAddressToBillingAddress = function () {
        this.billingDepartment = this.contactDepartment;
        this.billingAddressLine1 = this.contactAddressLine1;
        this.billingAddressLine2 = this.contactAddressLine2;
        this.billingAddressLine3 = this.contactAddressLine3;
        this.billingPostalCode = this.contactPostalCode;
        this.billingCity = this.contactCity;
        this.billingCountryCode = this.contactCountryCode;
        this.billingPhone = this.contactPhone;
        this.billingFax = this.contactFax;
        this.billingEmail = this.contactEmail;
    };
    Object.defineProperty(Organization.prototype, "currentLicenseTypeName", {
        get: function () {
            return (this.currentLicenseCategory === "Agentur" ? this.currentLicenseInitialLogins + " Zugriffe" : this.currentLicenseCategory);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Organization.prototype, "isCurrentLicenseActive", {
        get: function () {
            var today = DateUtils.currentDate();
            return (this.currentLicenseRemainingLogins > 0 && this.currentLicenseEndDate >= today);
        },
        enumerable: true,
        configurable: true
    });
    Organization.prototype.setNewLicenseType = function (newLicenseType) {
        if (newLicenseType) {
            // Copy the entire license type attributes so that
            // if the license type definition is changed later on,
            // the license request will still contain the exact
            // conditions shown to the user.
            this.newLicenseTypeName = newLicenseType.name;
            this.newLicenseTypeDescription = newLicenseType.description;
            this.newLicenseCategory = newLicenseType.category;
            this.newLicenseInitialLogins = newLicenseType.initialLogins;
            this.newLicenseIsPlanningEnabled = newLicenseType.isPlanningEnabled;
            this.newLicenseIsAdminEnabled = newLicenseType.isAdminEnabled;
            this.newLicensePriceNet = newLicenseType.priceNet;
            this.newLicenseTaxPercent = newLicenseType.taxPercent;
            this.newLicenseTax = newLicenseType.tax;
            this.newLicensePriceTotal = newLicenseType.priceTotal;
            this.newLicenseSignature = newLicenseType.signature;
        }
    };
    Organization.prototype.selectInitialNewLicenseType = function (availableLicenseTypes) {
        var _this = this;
        var currentLicenseType = availableLicenseTypes.find(function (licenseType) { return licenseType.category === _this.currentLicenseCategory && licenseType.initialLogins === _this.currentLicenseInitialLogins; });
        this.setNewLicenseType(currentLicenseType || availableLicenseTypes[0]);
    };
    Object.defineProperty(Organization.prototype, "earliestNewLicenseBeginDate", {
        get: function () {
            var today = DateUtils.currentDate();
            return (this.currentLicenseEndDate > today ? this.currentLicenseEndDate : today);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Organization.prototype, "formattedNewLicenseBeginDate", {
        get: function () {
            if (this.newLicenseBeginDate) {
                return DateUtils.formatAsLocalDate(this.newLicenseBeginDate);
            }
            if (this.isCurrentLicenseActive) {
                return "im Anschluss an aktuelle Lizenz";
            }
            return "sofort";
        },
        enumerable: true,
        configurable: true
    });
    return Organization;
}());
export { Organization };
